module.exports = __webpack_public_path__ + "r-v3/img/screen_on.3bae3e38.svg";